<template>
  <!--
      	作者：kmdshop
      	时间：2019-12-25
      	描述：插件中心-首页
      -->
  <div class="plus-container" v-loading="loading">


    <div v-for="(item, index) in listData" :key="index">

      <div class="common-form"  >{{ item.name }}</div>


      <div class="plus-list">
        <div class="item" v-for="(child, num) in item.children" :key="num" v-auth="child.path">
          <div class="item-box">
            <router-link :to="child.path">
              <span class="iconfont"><Icon :iconname="hasIcon(child.ico)"></Icon></span>
              <div class="ml10">
                <h3>{{ child.name }}</h3>
                <p>{{ child.remark }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

<!-- 
    <div>快捷生成应用模块</div>
    <el-form size="small" ref="form" :model="form" label-width="150px">

        <el-form-item label="应用名称" prop="plus_name" >
          <el-input v-model="form.plus_name" min=10 class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="应用名称（英文）" prop="plus_name_en" >
          <el-input v-model="form.plus_name_en"  min=10 class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="域名" prop="hosturl" >
          <el-input v-model="form.hosturl"  min=10 class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="shop端生成路径" prop="shop_gen_url" >
          <el-input v-model="form.shop_gen_url"  min=10 class="max-w460"></el-input>

          <div>路径后一定不能跟shop</div>
        </el-form-item>
        <el-form-item label="php端生成路径" prop="php_gen_url" >
          <el-input v-model="form.php_gen_url"  min=10 class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="权限菜单最高价ID（用于删除）" prop="new_access_id" >
          <el-input v-model="form.new_access_id"  min=10 class="max-w460"></el-input>
        </el-form-item>


     

        <el-form-item label="操作" prop="" >
          <el-button size="small" type="primary" @click="onSubmit(1)" :disabled="loading">生成前端</el-button>
          <el-button size="small" type="primary" @click="onSubmit(2)" :disabled="loading">删除前端</el-button>
          <el-button size="small" type="primary" @click="onSubmit(3)" :disabled="loading">生成后端</el-button>
          <el-button size="small" type="primary" @click="onSubmit(4)" :disabled="loading">删除后端</el-button>

          <el-button size="small" type="primary" @click="onSubmit(5)" :disabled="loading">创建数据库表</el-button>
          <el-button size="small" type="primary" @click="onSubmit(6)" :disabled="loading">删除表</el-button>

          <el-button size="small" type="primary" @click="onSubmit(7)" :disabled="loading">生成权限菜单</el-button>
          <el-button size="small" type="primary" @click="onSubmit(8)" :disabled="loading">删除权限菜单</el-button>

          <el-button size="small" type="primary" @click="onSubmit(9)" :disabled="loading">删除设置表</el-button>

         
        </el-form-item>


    </el-form> -->
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
var ind = 0;
export default {
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*数据*/
      listData:[],
      /*插件列表数据*/
      list: [],
      form:{
        plus_name:"",
        plus_name_english:"",
        shop_gen_url:"E:\\项目\\2024-5\\康采\\",
        php_gen_url:"D:\\phpstudy_pro\\WWW\\",
        hosturl:"yc.1.y01.cn",
        new_access_id:0


      }
    };
  },
  created() {
    this.getData();
  },

  methods: {
    onSubmit(code){
      let self = this;
      let parmas = self.form;
      parmas.code = code;
      PlusApi.genPlus(parmas, true)
        .then(res => {
        })
        .catch(error => {});
    },

    /*获取数据*/
    getData() {
      let self = this;
      PlusApi.plusList({}, true)
        .then(res => {
          self.loading = false;
          self.listData=res.data.list;
          //self.buildTree(data.data.list, false);
        })
        .catch(error => {});
    },

    /*构建树结构*/
    buildTree(list, flag) {
      if (!flag) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item.parent_id == 0) {
            item.children = [];
            this.list.push(item);
            list.splice(i, 1);
            i--;
          }
        }
      } else {
        for (let i = 0, leng = list.length; i < leng; i++) {
          let item = list[i];
          for (let j = 0, j_leng = this.list.length; j < j_leng; j++) {
            let j_item = this.list[j];
            if (item.parent_id == j_item.plus_id) {
              j_item.children.push(item);
              list.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }

      if (!flag) {
        this.buildTree(list, true);
      }
      return;
    },

    /*生成二级菜单 并把子集的以下全编程二级*/
    /* buildTree(list) {
      for (let i = 0, leng = list.length; i < leng; i++) {
        let item = list[i];
        if (item.parent_id == 0) {
          item.children = [];
          this.list.push(item);
          list.splice(i,1);
          i--;
        } else {
          for (let j = 0, j_leng = this.list.length; j < j_leng; j++) {
            let j_item = this.list[j];
            if (item.parent_id == j_item.plus_id) {
              j_item.children.push(item);
              list.splice(i,1);
              i--;
              break;
            }
            else{
              for(let p=0,p_leng=j_item.children.length;p<p_leng;p++){
                let child=j_item.children[p];
                if(item.parent_id==child.plus_id){
                  j_item.children.push(item);
                  list.splice(i,1);
                  i--;
                  break;
                }
              }
            }
          }
        }
      }
      if(list.length>0){
        this.buildTree(list);
      }
      return;
    }, */

    //判断是否有图标
    hasIcon(e) {
      if (e != null && e.length > 0) {
        return e;
      } else {
        return '#icon-shop-applications';
      }
    }
  }
};
</script>

<style>
  .plus-container{ min-height: 400px;}
.plus-container .common-form{ margin-bottom: 0;}
.plus-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.plus-list .item {
  width: 25%;
}
.plus-list .item .item-box {
  padding: 10px;
}
.plus-list .item a {
  display: flex;
  height: 60px;
  padding-left: 10px;
  justify-content: flex-start;
  align-items: center;
}
.plus-list .item a h3 {
  font-weight: normal;
  color: #333333;
}
.plus-list .item a:hover h3 {
  color: #3a8ee6;
}
.plus-list .item a p {
  font-size: 12px;
  color: #999999;
}
.plus-list .item .item-box .iconfont {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  line-height: 40px;
  background: #3a8ee6;
}
.plus-list .item a .svg-icon {
  width: 20px;
  height: 20px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/plus/index.vue